import React from 'react';
import './Alert.css';

/**
 * Static preview of the SchoolEngineAlert page, driven by props instead of API calls.
 * Mimics the live layout so authors can see exactly what end users will view.
 */
export default function AlertPreviewScreen({
    variant = 'active',
    title,
    message,
    backgroundColor,
    textColor
}) {
    const isEnded = variant === 'ended';
    const containerStyle = {
        backgroundColor,
        color: textColor
    };

    return (
        <div className="alert-preview-app" style={containerStyle}>
            <div className="alert-preview-body">
                <main className="alert-preview-panel">
                    {isEnded ? (
                        <section className="alert-preview-content alert-preview-content--ended">
                            <p className="alert-preview-label">Alert finished</p>
                            <h1 className="alert-preview-heading">{title}</h1>
                            <p className="alert-preview-message">{message}</p>
                        </section>
                    ) : (
                        <>
                            <section className="alert-preview-content">
                                <p className="alert-preview-label">ACTIVE ALERT</p>
                                <h1 className="alert-preview-heading">{title}</h1>
                                <p className="alert-preview-message">{message}</p>
                            </section>

                            <section className="alert-preview-composer">
                                <button className="alert-preview-composer-btn" type="button" disabled>
                                    Send message to alert manager
                                </button>
                            </section>

                            <section className="alert-preview-audio">
                                <button className="alert-preview-audio-btn" type="button" disabled>
                                    Mute alert audio
                                </button>
                                <button className="alert-preview-audio-btn alert-preview-audio-btn--ghost" type="button" disabled>
                                    Enable alert audio
                                </button>
                            </section>
                        </>
                    )}
                </main>
            </div>

            <footer className="alert-preview-footer">
                <div className="alert-preview-footer__meta">
                    <span className="alert-preview-footer__line"><strong>Device:</strong> Example-PC</span>
                    <span className="alert-preview-footer__line"><strong>User:</strong> Demo User</span>
                </div>
                <div className="alert-preview-footer__brand">
                    <span>System powered by</span>
                    <img src="/SE Alert.png" alt="School Engine Alert logo" className="alert-preview-footer__logo" />
                </div>
            </footer>
        </div>
    );
}
